import { useState, useEffect } from 'react'
import { useParams, useNavigate, useLocation } from "react-router-dom"
// services
import * as accountService from '../../../services/accountService'
// styles
import styles from "./ExhibitorSetup.module.css"
// components
import LoadingSpinner from "../../../components/Miscellaneous/LoadingSpinner"
import HoverButton from '../../../components/Miscellaneous/HoverButton'
import ChildItem from '../../../components/Account/ExhibitorSetup/ChildItem'
const ExhibitorSetup = ({ user }) => {
    const navigate = useNavigate()
    const location = useLocation()
    const stateData = location.state
    var exhibitorAccount = stateData['exhibitorAccount']
    var passedUser = stateData['user'] 
    const [loaded, setLoaded] = useState(false);
    const [message, setMessage] = useState("")
    const [messageColor, setMessageColor] = useState('green')
    const [children, setChildren] = useState([]);
    const [email, setEmail] = useState(null)
    const [processing, setProcessing] = useState(false)

    const isEmailInvalid = () => {
        if (!email) return false; // empty field is valid for local download
        const validEmailRegex = /^[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
        const emailParts = email.split('@');

        if (emailParts.length !== 2) return true;
        const account = emailParts[0];
        const domain = emailParts[1];

        if (account.length > 64) return true;
        else if (domain.length > 255) return true;

        const domainParts = domain.split('.');

        if (domainParts.some((part) => part.length > 63)) return true;

        return !(validEmailRegex.test(email));
    }
    const handleChange = (e) => {
        setEmail(e.target.value)
    }
   
    const createRequestBody = async () => {

        let requestBody = {}
        requestBody =
        {
            "userName": `${email}`,
        }
        return await requestBody;
    }
    const handleSubmit = async e => {
        e.preventDefault()
        setProcessing(true)
        const getReqBody = await createRequestBody()
        try {
            // send email/invitation to new exhibitor/admin
            await accountService.addUpdateAccount(getReqBody);
            setMessage('Invite Sent!')
            setMessageColor('green')
        } catch (err) {
            setMessage(err.message)
            setMessageColor('red')
        }
        setProcessing(false)
    }
    
    const fetchChildren = async (id) => {
        let children = await accountService.getAccountChildren(id);
        if (children && children.length > 0) {
            setChildren(children);
        }
        setLoaded(true);
    }
    useEffect(() => {
        setProcessing(false)
        if (exhibitorAccount.id && exhibitorAccount.id !== undefined) {
            fetchChildren(exhibitorAccount.id)
        }
    }, [])
    return (
         <>{!loaded ? <LoadingSpinner /> :
            <>
                <div className={styles.exhibitorSetupContainer}>
                    <h1>Exhibitor Portal</h1><br />
                    <h2>Vendor Accounts for: {exhibitorAccount.firstName} {exhibitorAccount.lastName}</h2><br />
                    <h2>Profile Details</h2><br />
                    <p><strong>Exhibitor account creation is not intended for all clients - only suggested for teams with numerous licenses that require autonomy/don't want to use same login.</strong>
                        <br />
                        <ul>Exhibitor accounts are secondary accounts that have fewer/limited abilites:</ul>
                        <li style={styles.liChildren }>Print/email leads of their scans only</li>
                        <li style={styles.liChildren}>Retrieve appcodes for the lead retrieval app</li>
                        <li style={styles.liChildren}>Create/Organize Qualifiers for themselves</li>
                        <strong>Name:</strong> Exhibitor Account first and last name.
                        <strong>UserId:</strong> Login email.
                        <strong>Activate/Deactivate:</strong> Activate or deactivate accounts.
                        <strong>Resend Verification Email:</strong> Only for unconfirmed accounts. Sends code to user to confirm their email account, finishing the registration process.
                    </p><br /><br />
                    <br /> <br />
                    <label> <strong>Enter Email to invite/create new exhibitor.</strong> </label>
                    <input
                        type='email'
                        value={email}
                        onChange={handleChange} // option selected
                        name='email'
                        placeholder='Enter Email...'
                    />
                    <br />
                    <button onClick={e => handleSubmit(e)} disabled={processing || isEmailInvalid()} >
                       Email Invite
                    </button>
                    {
                        message ?
                            <h2 style={{ color: messageColor }}>{message}</h2> :
                            <></>
                    }
                    <br />
                </div>
                {children && children.length > 0 ?
                    <>
                        <table className={styles.tableChilds}>
                            <thead>
                                <tr className={styles.trChilds}>
                                    <th className={styles.thChilds}>
                                        Name
                                        <HoverButton
                                            title={'Child name'}
                                            messageWidth={75}
                                        />
                                    </th>
                                    <th className={styles.thChilds}>
                                        User name
                                        <HoverButton
                                            title={'Child user name'}
                                            messageWidth={75}
                                        />
                                    </th>
                                    <th className={styles.thChilds}>
                                        Activate/Deactivate
                                        <HoverButton
                                            title={'Allows/disallows access to exhibitor data'}
                                            messageWidth={75}
                                        />
                                    </th>
                                </tr>
                            </thead>
                            <tbody key={children.length}>
                                {children.map((item, index) => (
                                    <ChildItem
                                        index={index}
                                        child={item}
                                    >
                                    </ChildItem>
                                ))}
                            </tbody>

                        </table>

                    </>
                    :
                    <div>
                        <div className={styles.errorChildsMessage}> No children found!</div>
                    </div>
                }
            </>
            }
                <br /><br />
                <button id={styles.backButton} onClick={() => navigate(-1)}> Back </button>
            </>
    );
}
export default ExhibitorSetup;